
// TODO: Fetcha:260206 Fetch currency from API
export const formatCurrency = (amount: string, userLanguage: 'es' | 'en') => {
  const numAmount = parseFloat(amount);
  if (isNaN(numAmount)) return amount;
  return new Intl.NumberFormat(userLanguage === 'es' ? 'es-ES' : 'en-US', {
    style: 'currency',
    currency: 'EUR', // Default currency for incident expenses if not specified
    minimumFractionDigits: 2,
  }).format(numAmount);
};
